import Tooltip from 'style-guide/Tooltip';
import Title from 'style-guide/Typography/Title';
import Label from 'style-guide/Label';
import UserAvatar from 'style-guide/UserAvatar';
import Text from 'style-guide/Typography/Text';
import theme from 'style-guide/Theme';
import Button from 'style-guide/Button';
import { message } from 'style-guide/ToastMessages';

const tooltipOverlayStyle = {
  maxWidth: '260px',
  backgroundColor: 'white',
  fontSize: '14px',
  color: 'black',
  boxShadow: '5px 10px 18px rgba(0, 0, 0, 0.25)',
  padding: '8px',
  borderRadius: '16px',
};

export const getAttachSurveyModalColumns = (updateSurvey, onClose, isReplace) => [
  {
    title: 'Survey',
    dataIndex: 'survey',
    key: 'survey',
  },
  {
    title: 'Linked LC',
    dataIndex: 'linkedLC',
    key: 'linkedLC',
    render: (value) => {
      const getLabelType = value.length > 0 ? 'processing' : 'default';
      const labelText = value.length > 0 ? `Linked to: ${value.length} LC` : 'Not linked';
      return (
        <Tooltip
          $disabled={!value.length}
          overlayInnerStyle={tooltipOverlayStyle}
          overlay={
            <div>
              <Title variant={5}>Linked LC's</Title>
              <ol type='1'>
                {value?.slice(0, 3).map((course) => (
                  <li key={course.id} className='mb--8'>
                    {course.name}
                  </li>
                ))}
                {value.length > 3 && <li className='mb--8'>and {value.length - 3} others...</li>}
              </ol>
            </div>
          }
          placement='top'
        >
          <Label type={getLabelType}>{labelText}</Label>
        </Tooltip>
      );
    },
  },
  {
    title: 'Created by',
    dataIndex: 'createdBy',
    key: 'createdBy',
    render: (value) => (
      <div className='d-flex align-items-center'>
        <UserAvatar userName={value.userName} picture={value.profileImage || null} className='mr--8' />
        <Text $variant={2} color={theme().colors.dark[80]} $ellipsis>
          {value.userName || 'Unknown User'}
        </Text>
      </div>
    ),
  },
  {
    title: 'Last updated',
    dataIndex: 'lastUpdated',
    key: 'lastUpdated',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    render: (value) => (
      <Button
        variant='link'
        onClick={async () => {
          try {
            await updateSurvey({
              isReplace,
              id: value.surveyId,
              chapterId: [+value.chapterId],
              courseId: [+value.courseId],
            }).unwrap();
            onClose?.();
          } catch (e) {
            message.error('Failed to update survey');
          }
        }}
      >
        {isReplace ? 'Replace' : 'Attach'}
      </Button>
    ),
  },
];
